import { types } from "../../types";

const initialState = {
    pagination: {
        data: [],
        per_page: 5,
    },
    openForm: false,
    openDetail: false,
    //    active: JSON.parse(localStorage.getItem("ticket-support-ti")) || null,
    active: null,
    user: "",
    messages: [],
};

export const ticketsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.showTicket:
            return {
                ...state,
                pagination: action.payload.pagination,
            };
        case types.openDetailTicket:
            return {
                ...state,
                openDetail: true,
            };
        case types.closeDetailTicket:
            return {
                ...state,
                openDetail: false,
                active: null,
            };

        case types.openFormTicket:
            return {
                ...state,
                openForm: true,
            };
        case types.closeFormTicket:
            return {
                ...state,
                openForm: false,
                active: null,
            };
        case types.setActiveTicket:
            return {
                ...state,
                active: action.payload,
            };
        case types.unsetActiveTicket:
            return {
                ...state,
                active: null,
            };
        case types.reloadChatTicket:
            return {
                ...state,
                messages: action.payload,
            };
        case types.clearChatTI:
            return {
                ...state,
                messages: [],
            };
        default:
            return state;
    }
};
